import { todoCache, createFolderIdDescriptor } from '../todoCache';

export default async function fetchAndSubscribeToTasks(tasksParentFolderId: string): Promise<void> {
    if (tasksParentFolderId) {
        await todoCache.fetchTasks(createFolderIdDescriptor(tasksParentFolderId), false);
    }
    todoCache.subscribeNotifications();
}
